import React, { useEffect, useState } from 'react'
import { Accordion, Icon } from 'semantic-ui-react';
import AccessRightsService from '../../../../../../../services/api/access-rights.service';
import RoleService from '../../../../../../../services/api/role.service';
import APIResponse from '../../../../../../templates/components/APIResponse';

const ViewAccess = (props) => {
    const [allFeatureList, setAllFeatureList] = useState()
    const [featureList, setFeatureList] = useState()
    const [loader, setLoader] = useState(false)
    const [activeIndex, setActiveIndex] = useState()

    const [apiResponse, setApiResponse] = useState()
    const onSuccess = (message) => {
        if (props.refresh) {
            props.refresh()
        }
        if (props.onClose) {
            props.onClose()
        }
        if (props.exitHandler) {
            props.exitHandler()
        }
    }

    const submitHandler = ( ) => {
        let data = props?.role;
        data.featuresList = allFeatureList.filter(feature => feature.hasAccess == 1).map(feature => feature.featureId);
        let providerId;
        if (props.practiceId) {
            providerId = props.practiceId;
        }
        RoleService.update(data, props.id, providerId)
        .then(res => {
            setApiResponse(res);
        })
        .catch(err => {
            setApiResponse(err);
        })
    };

    const getRoleFeatures = () => {
        setLoader(true)
        let providerId;
        if (props.practiceId) {
            providerId = props.practiceId;
        }
        RoleService.getById(props.id, providerId)
        .then(res => {
            console.log(res)
            // setRoleFeatures(res?.data?.featuresList)
            pullFeatureList(res?.data?.featuresList);
        })
    }

    const pullFeatureList = (newRoleFeatures) => {
        let reqObj = {}
        if (props.practiceId) {
            reqObj.practiceId = props.practiceId;
        }
        AccessRightsService.getfeatureConfig(reqObj)
            .then(res => {
                setLoader(false)
                console.log(res)
                res = res.map(feature => {
                    feature.hasAccess = 0;
                    if (newRoleFeatures.some(roleFeature => roleFeature.featureId == feature.featureId)) {
                        feature.hasAccess = 1;
                    }
                    return feature;
                });
                setAllFeatureList(res);
                setFeatureList(AccessRightsService.parseModules(res))
            })
    }

    const ModuleEnum = {
        14: "Appointment Management",
        3: 'Claims Management',
        16: "Eligibility Management",
        13: "Email Notifications",
        10: "Forms Management",
        7: "Insurance Management",
        2: 'Patient Checkout',
        1: 'Patient Management',
        5: "Payment Plans",
        9: "Provider Management",
        15: "Reports",
        17: "Role Management",
        6: "Settings",
        12: "SMS Notifications",
        11: "Training Videos",
        4: "Transactions",
        8: "User Management",
    }
    

    const updateRoleFeature = (changed, checked) => {
        changed.hasAccess = checked ? 1 : 0;
        let newList = [...allFeatureList]
        newList.map((feature, idx) => {
            if (feature.featureId == changed.featureId) {
                feature.hasAccess = changed.hasAccess
            }
        })
        setAllFeatureList(newList);
        setFeatureList(AccessRightsService.parseModules(newList))
    }

    useEffect(() => {
        getRoleFeatures()
    }, [])
    return (
        <>
        <div className='col-12 mt-3'>
            <Accordion fluid styled>
                {featureList && featureList.map((feature, idx) => {
                    if (feature.data.length > 0)
                        return (<>
                            <Accordion.Title
                                active={activeIndex === idx}
                                index={idx}
                                onClick={e => { e.preventDefault(); if (activeIndex === idx) { setActiveIndex() } else { setActiveIndex(idx) } }}
                            > <Icon name='dropdown' />{ModuleEnum[feature.key]
                                }</Accordion.Title>
                            <Accordion.Content active={activeIndex === idx}>
                                <table className='table table-borderless'>
                                    <thead>
                                        <th>Feature ID</th>
                                        <th>Feature Name</th>
                                        {/* <th>Email Access</th>
                                        <th>SMS Access</th>
                                        <th>Email Opt-In</th>
                                        <th>SMS Opt-In</th> */}
                                        <th>Active</th>
                                    </thead>
                                    <tbody>
                                        {feature.data.map(mod => {
                                            if (props?.fromAdmin || (mod.featureId>= 9000000 ))
                                            return (
                                                <tr>
                                                    <td> {mod.featureId}</td>
                                                    <td> {mod.featureName}</td>
                                                    {/* <td className='form-switch form-check'><span className='w-100 d-flex justify-content-center'><input type="checkbox" role="switch" checked={mod.hasEmail === 1 ? true : false} className='form-check-input' disabled /></span></td>

                                                    <td className='form-switch form-check'><span className='w-100 d-flex justify-content-center'><input type="checkbox" role="switch" checked={mod.hasSms === 1 ? true : false} className='form-check-input' disabled /></span></td>

                                                    <td className='form-switch form-check'><span className='w-100 d-flex justify-content-center'><input type="checkbox" role="switch" checked={mod.isEmailEnabled} className='form-check-input' disabled /></span></td>

                                                    <td className='form-switch form-check'><span className='w-100 d-flex justify-content-center'><input type="checkbox" role="switch" checked={mod.isSmsEnabled} className='form-check-input' disabled /></span></td> */}
                                                    <td className='form-switch form-check'><span className='w-100 d-flex justify-content-center'><input type="checkbox" role="switch" checked={mod.hasAccess === 1 ? true : false}  onChange={e => { updateRoleFeature(mod, e.target.checked) }}  className='form-check-input' /></span></td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </Accordion.Content>
                        </>)
                })}
            </Accordion>
        </div>
        <div className='col-12 d-flex justify-content-between mt-3'>
            <div className='col-auto'>
                <button className='btn btn-secondary' onClick={e => { e.preventDefault(); props.onClose() }}>Close</button>
            </div>
            <div className='col-auto'>
                <button className='btn btn-primary' onClick={e => { e.preventDefault(); submitHandler() }}>Save</button>
            </div>
        </div>
        <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} toastOnSuccess={true} />
        </>
    )
}
export default ViewAccess